import React from 'react';
import moment from 'moment';
import { Spring } from 'react-spring';
import Loading from '../../components/Loading/Loading';
import HeaderComponent from '../../components/Header';
import { API_ROOT_URL } from '../../config';
import doctorLogo from '../../static/images/doctorLogo.png';
import comingSoon from '../../static/images/comingsoon.png';
import notfound from '../../static/images/notfound.png';
import allowcamera from '../../static/images/allowcamera.png';
import { authActions, LanguagesActions } from '../../store/actions';
import { connect } from 'react-redux';
import image1 from '../../static/images/1.svg';
import image2 from '../../static/images/2.svg';
import image3 from '../../static/images/3new.svg';
import image4 from '../../static/images/3.svg';
import Footer from '../../components/Footer/footer';
import Swal from 'sweetalert2';
import { constants } from '../../Constants';
import { history } from '../../helpers';
import '../../static/css/styles.css';
import ReactTooltip from 'react-tooltip';

import CounsellorIcon from '../../static/images/counsellors.svg';
import WhitelabelIcon from '../../static/images/whitelabels.svg';
import ReportIcon from '../../static/images/reports.svg';
import AppointmentIcon from '../../static/images/appointment.svg';

class Home extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			dropdownValue: '0',
			selectedDate: '',
			normalState: true,
			searchedState: false,
			slot_id: '',
			session: [],
			searchedTimeSlots: [],
			counsellor_id: '',
			role: sessionStorage.getItem('role'),
			appointments: [],
			appointmentsChanged: false,
			allowedPermissions: false,
			resourceError: '',
		};
		this.textInput = React.createRef();

		
	}

	componentWillMount() {
		this.props.fetchLanguages()
		//this.props.getUserData();
		//this.props.getAppointments(project_id);
		// if (this.props.user !== undefined) {
		// 	if (this.props.user.role === 0) {
		// 		history.push('/home/counsellor');
		// 	}
		// }
	}

	componentDidMount() {
		// console.log('this.props', this.props.user)
		//console.log('localStorage.getItem :', localStorage.getItem('session_ended'))
		// if (localStorage.getItem('session_ended')){
		// 	localStorage.removeItem('session_ended');
		// 	window.location.reload(true)
		// }
		// this.browserDetcet();
		//this.checkPermissions();
	}
	componentWillReceiveProps(nextProps) {
		// this.setState({
		// 	appointments: nextProps.appointments,
		// 	appointmentsChanged: false,
		// });
	}

	openNotes = () => {
		history.push('/note');
	};

	/* Check Browser and OS */

	redirectCounsellorReports = () => {
		history.push('/counsellor-reports')
	}
	redirectCorporateReports = () => {
		history.push('/corporate-reports')
	}
	createCounsellor = (e) => {
		const { permissions_with_status } = this.props.user;
		if (!permissions_with_status['user.add_counsellor'])
			e.preventDefault();
		else
			history.push('/create-counsellor');
	};
	redirectCounsellors = (e) => {
		const { permissions_with_status } = this.props.user;
		if (!permissions_with_status['user.view_counsellor'])
			e.preventDefault();
		else
			history.push('/counsellors');
	};
	redirectWhitelabel = (e) => {
		const { permissions_with_status } = this.props.user;
		if (!permissions_with_status['project.view_project'])
			e.preventDefault();
		else
			history.push('/projects');
	};

	redirectCreateAppointment = (e) => {
		const { permissions_with_status } = this.props.user;
		if (!permissions_with_status['project.view_project'])
			e.preventDefault();
		else
			history.push('/create-appointment')
	}

	redirectHome = () => {
		history.push('/home');
	};
	createWhitelabel = (e) => {
		const { permissions_with_status } = this.props.user;
		if (!permissions_with_status['project.add_project'])
			e.preventDefault();
		else
			history.push('/create-project');
	};

	render() {
		const { permissions_with_status } = this.props.user;
		return (
			<div className="ContainerFix">
				<HeaderComponent />
				<Spring from={{ transform: 'translate(+100%, 0)' }} to={{ transform: 'translate(0%, 0)' }}>
					{(props) => (
						<div className="containerFlex" style={props}>
							<div className="container-wrap">
								<div className="row justify-content-center mt-5 mx-auto w-75 pb-5" id="cardButtonContainer">
									<div className="card-button p-3">
										<img
											className=" pt-2 pb-3 pl-5 pr-5 dashboard-icons"
											src={CounsellorIcon}
											width="150px"
											height="150px"
											alt="scheduling icon"
										/>
										<div className="text-center dashboard-button-text pb-3 dashboard-card-heading">
											{constants.COUNSELLORS}
										</div>
										<a
											className={`dashboard-card-item ${!permissions_with_status['user.add_counsellor'] ? 'disableCursor' : ''}`}
											onClick={this.createCounsellor}
											disabled={!permissions_with_status['user.add_counsellor']}
											data-tip
											data-for="tooltip"
											data-tip-disable={permissions_with_status['user.add_counsellor']}
										>
											{constants.CREATE_COUNSELLOR_TXT}
										</a><br />
										<a
											className={`dashboard-card-item ${!permissions_with_status['user.view_counsellor'] ? 'disableCursor' : ''}`}
											onClick={this.redirectCounsellors}
											disabled={!permissions_with_status['user.view_counsellor']}
											data-tip
											data-for="tooltip"
											data-tip-disable={permissions_with_status['user.view_counsellor']}
										>
											{constants.LIST_COUNSELLORS_TXT}
										</a>
									</div>
									<div className="card-button p-3">
										<img
											className=" pt-2 pb-3 pl-5 pr-5 dashboard-icons"
											src={WhitelabelIcon}
											width="150px"
											height="150px"
											alt="notes icon"
										/>
										<div className="text-center dashboard-button-text pb-3 dashboard-card-heading">
											{constants.WHITELABELS_TXT}
										</div>
										<a
											className={`dashboard-card-item ${!permissions_with_status['project.add_project'] ? 'disableCursor' : ''}`}
											onClick={this.createWhitelabel}
											disabled={!permissions_with_status['project.add_project']}
											data-tip
											data-for="tooltip"
											data-tip-disable={permissions_with_status['project.add_project']}
										>
											{constants.CREATE_WHITELABEL_TXT}{' '}
										</a> <br />
										<a
											className={`dashboard-card-item ${!permissions_with_status['project.view_project'] ? 'disableCursor' : ''}`}
											onClick={this.redirectWhitelabel}
											disabled={!permissions_with_status['project.view_project']}
											data-tip
											data-for="tooltip"
											data-tip-disable={permissions_with_status['project.view_project']}
										>
											{constants.LIST_WHITELABEL_TXT}
										</a>
									</div>
									<div className="card-button p-3">
										<img
											className=" pt-2 pb-3 pl-5 pr-5 dashboard-icons"
											src={ReportIcon}
											width="150px"
											height="150px"
											alt="wellbeing icon"
										/>
										<div className="text-center dashboard-button-text pb-3 dashboard-card-heading">{constants.REPORTS_TEXT}</div>
										<a className="dashboard-card-item" onClick={this.redirectCorporateReports}>{constants.CORPORATE_REPORTS_TXT}</a> <br />
										<a className="dashboard-card-item" onClick={this.redirectCounsellorReports}>{constants.COUNSELLOR_REPORTS_TXT}</a>
									</div>
									<div className="card-button p-3">
										<img
											className=" pt-2 pb-3 pl-5 pr-5 dashboard-icons"
											src={AppointmentIcon}
											width="150px"
											height="150px"
											alt="wellbeing icon"
										/>
										<div className="text-center dashboard-button-text pb-3 dashboard-card-heading">{constants.APPOINTMENT_TXT}</div>
										<a
											className={`dashboard-card-item ${!permissions_with_status['appointment.add_appointment'] ? 'disableCursor' : ''}`}
											onClick={this.redirectCreateAppointment}
											disabled={!permissions_with_status['appointment.add_appointment']}
											data-tip
											data-for="tooltip"
											data-tip-disable={permissions_with_status['appointment.add_appointment']}
										>
											{constants.CREATE_APPOINTMENT_TXT}
										</a>
									</div>
								</div>
								<ReactTooltip id="tooltip" effect="solid">
									<div className="disabledTooltip" id="divSessionTooltip">
										<span>{constants.PERMISSIONS_TXT}</span>

									</div>
								</ReactTooltip>
							</div>
						</div>
					)}

				</Spring>
				<Footer />
			</div>
		);
	}
}

function mapStateToProps(state) {
	const { auth, alert } = state;
	const { user } = auth;
	return {
		user,
		alert,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
		getUserData: () => {
			dispatch(authActions.getUserData());
		},
		fetchLanguages: () => {
			dispatch(LanguagesActions.fetchLanguages());
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/screens/Home/index.js